import Modal from '@rd-web-markets/shared/dist/util/Modal';
import React from 'react';
import { Table } from '../util';
const BackgroundJobErrorsModal = _ref => {
  let {
    jobStatusObject,
    errorTableHeaders,
    buildErrorTableRowFn,
    errorsArrayPropertyName,
    title,
    onHide,
    show,
    size = 'lg'
  } = _ref;
  const rows = () => {
    return (jobStatusObject && (jobStatusObject[errorsArrayPropertyName] || [])).map((error, index) => buildErrorTableRowFn(error, index));
  };
  const modalBody = () => {
    return /*#__PURE__*/React.createElement(Table, {
      headers: errorTableHeaders,
      rows: rows(),
      showControls: false
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    size: size,
    title: title,
    renderBody: () => modalBody(),
    onHide: onHide
  });
};
export default BackgroundJobErrorsModal;